import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { SystemProvider } from "@/lib/system";
import { NotificationsProvider } from "@/lib/notifications";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tickets from "@/pages/Tickets";
import TicketNew from "@/pages/TicketNew";
import TicketDetail from "@/pages/TicketDetail";
import Knowledge from "@/pages/Knowledge";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Roles from "@/pages/Roles";
import Import from "@/pages/Import";
import BankResponse from "@/pages/BankResponse";
import Merchants from "@/pages/Merchants";
import BulkEdit from "@/pages/BulkEdit";
import Broadcast from "@/pages/Broadcast";
import HealthCheck from "@/pages/HealthCheck";
import Monitoring from "@/pages/Monitoring";
import AgentReports from "@/pages/AgentReports";
import MerchantAnalytics from "@/pages/MerchantAnalytics";
import AppLayout from "@/components/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm" data-testid="auth-loading">Authenticating...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SystemProvider>
            <NotificationsProvider>
              <Toaster theme="dark" position="top-right" />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Protected><Dashboard /></Protected>} />
                <Route path="/tickets" element={<Protected><Tickets /></Protected>} />
                <Route path="/tickets/new" element={<Protected><TicketNew /></Protected>} />
                <Route path="/tickets/:id" element={<Protected><TicketDetail /></Protected>} />
                <Route path="/knowledge" element={<Protected><Knowledge /></Protected>} />
                <Route path="/team" element={<Protected><Team /></Protected>} />
                <Route path="/merchants" element={<Protected><Merchants /></Protected>} />
                <Route path="/import" element={<Protected><Import /></Protected>} />
                <Route path="/bank-response" element={<Protected><BankResponse /></Protected>} />
                <Route path="/bulk-edit" element={<Protected><BulkEdit /></Protected>} />
                <Route path="/broadcast" element={<Protected><Broadcast /></Protected>} />
                <Route path="/healthcheck" element={<Protected><HealthCheck /></Protected>} />
                <Route path="/monitoring" element={<Protected><Monitoring /></Protected>} />
                <Route path="/agent-reports" element={<Protected><AgentReports /></Protected>} />
                <Route path="/merchant-analytics" element={<Protected><MerchantAnalytics /></Protected>} />
                <Route path="/settings" element={<Protected><Settings /></Protected>} />
                <Route path="/settings/roles" element={<Protected><Roles /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </NotificationsProvider>
          </SystemProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
